/**
 * @changelog
 *
 *
 * 2026-02-28 (0.1.0) (jhoward)
 *   - Add /account/info/view route for viewing account info.
 *
 * 2026-03-11 (0.2.0) (jhoward)
 *   - Replace src\router\accountRoutes entry for '/account/info/view' with new '/offers', '/info', and '/win-loss' routes.
 *   - Add meta fields 'pageTitle' and 'twoFactorAuthRequired' to all routes.
 *   - Switch to dynamic imports for some components for improved code splitting.
 *   - BREAKING: Route names and paths changed; consumers using old paths/names must update.
 *
 * 2026-04-09 (0.3.0) (jhoward)
 *   - Add /reverify route mapped to Account/ReverifyAccount.vue.
 *
 * 2026-10-10 (0.4.0) (jhoward)
 *   - Add /account/security, the Sign-in & Security page: every sign-in method, recovery codes and remembered
 *     devices in one place, moved out of /info.
 */

import type { RouteRecordRaw } from 'vue-router';
import ViewOffers from '@/views/Account/ViewOffers.vue';

const accountRoutes: RouteRecordRaw[] = [
  {
    path: '/offers',
    name: 'account.offers',
    component: ViewOffers,
    meta: {
      pageTitle: 'Offers',
      authRequired: true,
      twoFactorAuthRequired: true,
    },
  },
  {
    path: '/info',
    name: 'account.info',
    component: () => import('@/views/Account/ViewAccountInfo.vue'),
    meta: {
      pageTitle: 'Account Information',
      authRequired: true,
      twoFactorAuthRequired: true,
    },
  },
  {
    path: '/account/security',
    name: 'account.security',
    component: () => import('@/views/Account/SecuritySettings.vue'),
    meta: {
      pageTitle: 'Sign-in & Security',
      authRequired: true,
      twoFactorAuthRequired: true,
    },
  },
  {
    path: '/win-loss',
    name: 'account.win-loss',
    component: () => import('@/views/Account/ViewWinLoss.vue'),
    meta: {
      pageTitle: 'Win/Loss Statements',
      authRequired: true,
      twoFactorAuthRequired: true,
    },
  },
  {
    path: '/reverify',
    name: 'account.reverify',
    component: () => import('@/views/Account/ReverifyAccount.vue'),
    meta: {
      pageTitle: 'Reverify Account',
      authRequired: true,
      twoFactorAuthRequired: true,
    },
  },
];

export default accountRoutes;
